var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v(_vm._s(_vm.value.name)+_vm._s(_vm.includeLevelInTitle ? " - " + _vm.value.levelName : ''))]),_c('detailed-competitors-list',{attrs:{"items":_vm.value.competitors,"showHeaders":false,"showOrder":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }